export const DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss'